{
  "LOGIN": {
    "TITLE": "Войти в контакт-центр",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Пожалуйста, введите действительный адрес электронной почты"
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль"
    },
    "API": {
      "SUCCESS_MESSAGE": "Вход выполнен",
      "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз.",
      "UNAUTH": "Неверное имя пользователя или пароль. Пожалуйста, попробуйте еще раз.",
      "ACCOUNT_DEACTIVATED": "Ваш аккаунт деактивирован. Пожалуйста, обратитесь к администратору.",
      "PASSWORD_LOGIN_DISABLED": "Вход по паролю отключён для вашего аккаунта. Пожалуйста, войдите через OAuth (например, Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Войти с помощью Google",
      "BUSINESS_ACCOUNTS_ONLY": "Пожалуйста, используйте адрес электронной почты вашей компании для входа",
      "NO_ACCOUNT_FOUND": "Мы не смогли найти учетную запись для вашего адреса электронной почты."
    },
    "FORGOT_PASSWORD": "Забыли пароль?",
    "CREATE_NEW_ACCOUNT": "Создать новый аккаунт",
    "SUBMIT": "Вход"
  }
}
